import { render } from "./BaseTab.vue?vue&type=template&id=c1aaea38&scoped=true"
import script from "./BaseTab.vue?vue&type=script&lang=js"
export * from "./BaseTab.vue?vue&type=script&lang=js"

import "./BaseTab.vue?vue&type=style&index=0&id=c1aaea38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1aaea38"]])

export default __exports__